import React, { Component } from 'react';
import Avatar from '../Avatar/Avatar';

import { Link } from 'react-router-dom';
import { centralizadoVerticalmente } from 'styles/Utilitarios';
import styled from 'styled-components';


export interface PessoaPossivelmenteSemNome {
  idInstitucional: string;
  nome?: string;
}

interface AvatarPessoaProps {
  /**
   * Informações básicas da pessoa:
   *  - Identificador institucional
   *  - Nome (opcional)
   */
  pessoa: PessoaPossivelmenteSemNome
  exibirNome?: boolean
  'aria-hidden'?: boolean
  ocultarTooltip?: boolean
  /**
   * O componente deve possuir um link para a pessoa?
   */
  comLink?: boolean
}


export default class AvatarPessoa extends Component<AvatarPessoaProps> {
  static defaultProps = {
    exibirNome: true,
    comLink: true
  }

  render() {
    const ariaHidden = this.props["aria-hidden"] === undefined 
      ? this.props.exibirNome
      : this.props["aria-hidden"]

    const content = <Container>
      <Avatar aria-hidden={ariaHidden} nome={this.props.pessoa.nome} />
      {this.props.exibirNome ? <><Nome>{this.props.pessoa.nome}</Nome>{this.props.children}</> : ''}
    </Container>

    return <>
      {
        this.props.comLink
          ? this.renderLink(this.props.pessoa, content)
          : content
      }
    </>;
  }

  renderLink(usuario: PessoaPossivelmenteSemNome, content: React.ReactNode) {
    const linkProps : any = {}

    if (!this.props.exibirNome) {
      linkProps['title'] = usuario.nome
    }

    if (this.props.pessoa.idInstitucional == null)
      console.warn(`Usuário ${usuario.nome} sem id definido`)


    return <Link to={"/usuarios/" + usuario.idInstitucional} {...linkProps} className="user">{content}</Link>
  }
}

const Container = styled.span`
  ${centralizadoVerticalmente};
`;

const Nome = styled.span`
  padding-left: 8px;
`;